import { FormFields, FormValidationSchema } from '@/common/interfaces';

import { SitesArchive } from '@/modules/Sites/Sites';

export enum SiteFormInputs {
  Name = 'name',
}

export type SiteFormFields = FormFields<typeof SiteFormInputs>;

export type SiteFormValidationSchema = FormValidationSchema<SiteFormFields>;

export enum SiteArchiveUploadStatus {
  Pending = 'pending',
  Success = 'success',
  InProcess = 'inProcess',
  Error = 'error',
}

export type SiteArchivesListTableDataObj = {
  id: string;
  key: number;
  name: SitesArchive['file']['name'];
  size: SitesArchive['file']['formattedSize'];
  status: SitesArchive['status'];
  pagesCount: SitesArchive['pagesCount'];
  filesCount: SitesArchive['filesCount'];
  processedAt: SitesArchive['processedAt'];
  createdAt: SitesArchive['createdAt'];
  downloadLink: SitesArchive['file']['url'];
  errorMessage: SitesArchive['errorMessage'];
};

export enum SiteArchivesGatewayKeys {
  UpdateUploadStatus = 'updateUploadStatus',
}

export enum SiteArchivesExportType {
  WithPlaceholders = 'withPlaceholders',
  WithData = 'withData',
}

export enum SiteArchivesExportFormInputs {
  SiteArchiveExportType = 'siteArchiveExportType',
}

export type SiteArchivesExportFormFields = FormFields<typeof SiteArchivesExportFormInputs>;

export type SiteArchivesExportFormValidationSchema = FormValidationSchema<SiteArchivesExportFormFields>;
